
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"top-n-information.TopBottom.TOP":"Größte","top-n-information.TopBottom.BOTTOM":"Kleinste"},"en":{"top-n-information.TopBottom.TOP":"Top","top-n-information.TopBottom.BOTTOM":"Bottom"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();